import { mapCollection } from '../../utils/collection.utils';
import { ToolHolderRebuildOption } from '../tool-holder-rebuild-option';
import { ToolRebuildOption } from '../tool-rebuild-option';

export class ToolHolderRebuildOptionBuilder {

  static buildToolHolderRebuildOptionFromJson(json) {
    return (json)
      ? new ToolHolderRebuildOption(
        json.hash,
        json.rebuildToolHolderPublicHash,
        json.rebuildToolHolderPublicName,
        json.rebuildOrder
      )
      : null;
  }

  static buildToolHolderRebuildOptionsFromList(list) {
    return mapCollection(ToolHolderRebuildOptionBuilder.buildToolHolderRebuildOptionFromJson, list);
  }

  static buildToolRebuildOptionFromJson(json) {
    return (json)
      ? new ToolRebuildOption(
        json.hash,
        json.rebuildToolPublicHash,
        json.rebuildToolPublicName,
        json.rebuildOrder
      )
      : null;
  }

  static buildToolRebuildOptionsFromList(list) {
    return mapCollection(ToolHolderRebuildOptionBuilder.buildToolRebuildOptionFromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/tool-rebuild-option.builder.ts